import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import logo from "../assets/logo-light.png"; // ✅ importa a logo
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await authService.login({ email, password });
      if (response.data?.token) {
        navigate("/");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Erro ao fazer login");
    }
  };

  return (
    <div className="login-container">
      {/* 🔹 Logo como marca d’água */}
      <div
        className="login-background"
        style={{ backgroundImage: `url(${logo})` }}
      ></div>

      <div className="login-content">
        <h1 className="login-title">Bem-vindo ao ScannerPro</h1>
        <p className="login-subtitle">Faça login para acessar o painel</p>

        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="login-button">
            Entrar
          </button>
          <button
            type="button"
            className="forgot-button"
            onClick={() => navigate("/forgot-password")}
          >
            Esqueci minha senha
          </button>
        </form>

        {error && <p className="error-message">{error}</p>}

        <div className="login-footer">
          <h3>💡 Sugestões</h3>
          <p>
            Envie suas ideias para melhorar o projeto:{" "}
            <strong>pro.scanners.pro@gmail.com</strong>
          </p>
          <p className="login-warning">
            ⚠️ O ScannerPro é destinado a apostadores profissionais. Seja
            responsável.
          </p>
        </div>
      </div>
    </div>
  );
}
